/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

import * as Storage from './storage.js'
import Constants from "./constants";

const isGuestUser = () =>{
    let userString = Storage.getItem(Constants.KEY_USER)
    let user = null

    if (userString){
        user = JSON.parse(userString)
    }

    if (user && user.usuario === 'invitado'){
        return 1
    }

    return 0
}

const getGuestUserToken = () => {
    if (isGuestUser() === 1) {
        return Storage.getItem(Constants.KEY_TOKEN_GUEST)
    }

    return null
}

const getUser = () => {
    let userString = Storage.getItem(Constants.KEY_USER)
    let user = null

    if (userString){
        user = JSON.parse(userString)
    }

    return user
}

const getUserId = () => {
    let user = getUser()

    if (user){
        return user.id
    }

    return null
}

export {
    isGuestUser,
    getGuestUserToken,
    getUser,
    getUserId
}